// extracted by mini-css-extract-plugin
export var chip = "_57-0";
export var filterDropdown = "_57-5";
export var filterItem = "_57-6";
export var icon = "_57-1";
export var removeButton = "_57-3";
export var removeIcon = "_57-4";
export var separator = "_57-2";